import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const HEADING2 = "HEADING2";
export const HEADING2_P1 = "HEADING2_P1";
export const HEADING2_P2 = "HEADING2_P2";
export const HEADING2_P3 = "HEADING2_P3";
export const HEADING2_P4 = "HEADING2_P4";
export const HEADING2_P5 = "HEADING2_P5";
export const HEADING2_P6 = "HEADING2_P6";
export const HEADING2_P7 = "HEADING2_P7";
export const HEADING2_P8 = "HEADING2_P8";

export const PARTNERS = "PARTNERS";
export const PARTNERS_P1_1 = "PARTNERS_P1_1";
export const PARTNERS_P1_2 = "PARTNERS_P1_2";
export const PARTNERS_P2_1 = "PARTNERS_P2_1";
export const PARTNERS_P2_2 = "PARTNERS_P2_2";
export const PARTNERS_P3_1 = "PARTNERS_P3_1";
export const PARTNERS_P3_2 = "PARTNERS_P3_2";
export const PARTNERS_P4 = "PARTNERS_P4";
export const PARTNERS_P5_1 = "PARTNERS_P5_1";
export const PARTNERS_P5_2 = "PARTNERS_P5_2";
export const SUPPORTED_BY = "SUPPORTED_BY";
export const SUPPORTED_BY_P1 = "SUPPORTED_BY_P1";

export const ITSMC_HEADING = "ITSMC_HEADING";
export const ITSMC_P1 = "ITSMC_P1";
export const ITSMC_P2 = "ITSMC_P2";
export const ITSMC_P3 = "ITSMC_P3";
export const ITSMC_P4 = "ITSMC_P4";

export const BID_SEC_HEADING = "BID_SEC_HEADING";

export const BID_SEC_P1 = "BID_SEC_P1";

export const BID_SEC_LI1 = "BID_SEC_LI1";
export const BID_SEC_LI2 = "BID_SEC_LI2";
export const BID_SEC_LI3 = "BID_SEC_LI3";
export const BID_SEC_LI4 = "BID_SEC_LI4";
export const BID_SEC_LI5 = "BID_SEC_LI5";
export const BID_SEC_LI6 = "BID_SEC_LI6";
export const BID_SEC_LI7 = "BID_SEC_LI7";
export const BID_SEC_LI8 = "BID_SEC_LI8";

export const SUGGESTIONS = "SUGGESTIONS";

export const SUGGESTIONS_L1 = "SUGGESTIONS_L1";
export const SUGGESTIONS_L2 = "SUGGESTIONS_L2";
export const SUGGESTIONS_L3 = "SUGGESTIONS_L3";
export const SUGGESTIONS_L4 = "SUGGESTIONS_L4";
export const SUGGESTIONS_L5 = "SUGGESTIONS_L5";
export const SUGGESTIONS_L6 = "SUGGESTIONS_L6";
export const SUGGESTIONS_L7_1 = "SUGGESTIONS_L7_1";
export const SUGGESTIONS_L7_2 = "SUGGESTIONS_L7_2";

export const translations = {
  en: {
    [HEADING1]: "World Bank Funded Project",
    [HEADING2]: "About SUTP",
    [HEADING2_P1]: `Achieving sustainable urban transport has become a primary objective with the adoption of National Urban Transport Policy (NUTP) by the Government of India (GoI). Efforts to reduce or contain environmental risks form an important component of this objective. To foster a long-term partnership between GoI and state/local governments in the implementation of a greener environment under the ambit of the NUTP, GoI has initiated the Sustainable Urban Transport Project with the support of the Global Environment Facility (GEF). The total GEF grant proposed for the project is US$ 25 million, which will be complemented with a grant of US$ 170 million from GOI, State Governments, and Implementing Agencies (IA) along with US$ 105 million co-financing from the World Bank. The project is to be implemented over a four-year period starting from 2010. Primary Stakeholders in this program are Ministry of Urban Development (MoUD), Ministry of Environment and Forest (MoEF), UNDP and World Bank. MoUD is the nodal agency for this program implementation.`,
    [HEADING2_P2]:
      "Integrated and comprehensive institutional and capacity development programs needs to be developed and implemented at the national, state and local government levels. These are necessary to build sufficient institutional and human capacity to successfully address already severe and rapidly growing urban transport challenges. With this in mind, the Sustainable Urban Transport Project (SUTP) was developed. The two main objectives of SUTP are:",
    [HEADING2_P3]:
      "Strengthening capacity of GOI, Institute of Urban Transport (IUT), and participating states and cities in planning, financing, implementing, operating and managing sustainable urban transport systems",
    [HEADING2_P4]: `Assisting states and cities in preparing and implementing demonstration "Green Transport" projects`,
    [HEADING2_P5]:
      "SUTP is initiated by GoI with the support of the Global Environment Facility (GEF), World Bank and United Nations Development Program (UNDP)",
    [HEADING2_P6]:
      "Ministry of Urban Development (MoUD) is the nodal agency for the project",
    [HEADING2_P7]:
      "The implementation of SUTP is planned over the next four years. The total cost of the project is 1427.97 crores",
    [HEADING2_P8]: "For more details visit:www.sutpindia.com",
    [PARTNERS]: "Partners",
    [PARTNERS_P1_1]: "Ministry of Urban Development",
    [PARTNERS_P1_2]: "Government of India",

    [PARTNERS_P2_1]: "Global Environment Facility",
    [PARTNERS_P2_2]: "Investing in our Planet",

    [PARTNERS_P3_1]: "The World Bank",
    [PARTNERS_P3_2]: "Working for a World Free of Poverty",
    [PARTNERS_P4]: "United Nations Development Programme",

    [PARTNERS_P5_1]: "Ministry of Environment and Forests",
    [PARTNERS_P5_2]: "Government of India",

    [SUPPORTED_BY]: "Supported By",
    [SUPPORTED_BY_P1]: "Institute of Urban Transport (India)",

    [ITSMC_HEADING]: "Intelligent Transport System at Mysore City",
    [ITSMC_P1]: "Detailed Project Report",
    [ITSMC_P2]: "Project Agreement",
    [ITSMC_P3]: "Project Agreement",
    [ITSMC_P4]: "Loan Agreement",
    [BID_SEC_HEADING]: "Bid Section",
    [BID_SEC_P1]: "All the Tender Notifications related to ITS",

    [BID_SEC_LI1]: "Amendment to ITS Document",
    [BID_SEC_LI2]: "Bid Document ITS Implementation",
    [BID_SEC_LI3]: "EOI for PMC",
    [BID_SEC_LI4]: "Queries and Replies to ITS Tender",
    [BID_SEC_LI5]: "Request for EOI - Monitoring and Evaluation",
    [BID_SEC_LI6]: "Corrigendum for EOI - Monitoring and Evaluation",
    [BID_SEC_LI7]: "Award of Contracts",
    [BID_SEC_LI8]: "EOI for Comprehensive Service & Operational Analysis",
    [SUGGESTIONS]: "Suggestions",
    [SUGGESTIONS_L1]: "For any Complaints / Suggestions, Write to:",
    [SUGGESTIONS_L2]: "Managing Director,",
    [SUGGESTIONS_L3]: "Karnataka State Road Transport Corporation,",
    [SUGGESTIONS_L4]: "Central Offices, Transport House,",
    [SUGGESTIONS_L5]: "Shantinagar, Bangalore -560027",
    [SUGGESTIONS_L6]: "Karnataka, India",
    [SUGGESTIONS_L7_1]: "eMail:",
    [SUGGESTIONS_L7_2]: "md@ksrtc.org",
  },
  kn: {
    [HEADING1]: "ವಿಶ್ವ ಬ್ಯಾಂಕ್ ಅನುದಾನಿತ ಯೋಜನೆ",
    [HEADING2]: "SUTP ಬಗ್ಗೆ",
    [HEADING2_P1]:
      "ಭಾರತ ಸರ್ಕಾರವು (GoI) ರಾಷ್ಟ್ರೀಯ ನಗರ ಸಾರಿಗೆ ನೀತಿಯನ್ನು (NUTP) ಅಳವಡಿಸಿಕೊಳ್ಳುವುದರೊಂದಿಗೆ ಸುಸ್ಥಿರ ನಗರ ಸಾರಿಗೆಯನ್ನು ಸಾಧಿಸುವುದು ಮುಖ್ಯವಾದ ಉದ್ದೇಶವಾಗಿದೆ. ಪರಿಸರದ ಅಪಾಯಗಳನ್ನು ಕಡಿಮೆ ಮಾಡುವುವದು ಅದರಲ್ಲಿರುವ ಪ್ರಯತ್ನಗಳು ಈ ಉದ್ದೇಶದ ಪ್ರಮುಖ ಅಂಶವಾಗಿದೆ. NUTP ವ್ಯಾಪ್ತಿಯಡಿಯಲ್ಲಿ ಹಸಿರು ಪರಿಸರದ ಅನುಷ್ಠಾನದಲ್ಲಿ GoI ಮತ್ತು ರಾಜ್ಯ/ಸ್ಥಳೀಯ ಸರ್ಕಾರಗಳ ನಡುವೆ ದೀರ್ಘಾವಧಿಯ ಪಾಲುದಾರಿಕೆಯನ್ನು ಉತ್ತೇಜಿಸಲು, GoI (ಭಾರತ ಸರ್ಕಾರ) ಜಾಗತಿಕ ಪರಿಸರ ಸೌಲಭ್ಯ (GEF) ನ ಬೆಂಬಲದೊಂದಿಗೆ ಸುಸ್ಥಿರ ನಗರ ಸಾರಿಗೆ ಯೋಜನೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿದೆ. ಯೋಜನೆಗಾಗಿ ಪ್ರಸ್ತಾಪಿಸಲಾದ ಒಟ್ಟು GEF ಅನುದಾನವು US$ 25 ಮಿಲಿಯನ್ ಆಗಿದೆ, ಇದು (ಭಾರತ ಸರ್ಕಾರ) GOI, ರಾಜ್ಯ ಸರ್ಕಾರಗಳು ಮತ್ತು ಇಂಪ್ಲಿಮೆಂಟಿಂಗ್ ಏಜೆನ್ಸಿಗಳಿಂದ (IA) US$ 170 ಮಿಲಿಯನ್ ಅನುದಾನದೊಂದಿಗೆ ಪೂರಕವಾಗಿದೆ ಜೊತೆಗೆ ವಿಶ್ವಬ್ಯಾಂಕ್ ನಿಂದ US$ 105 ಮಿಲಿಯನ್ ಸಹ-ಹಣಕಾಸು. ಯೋಜನೆಯು 2010 ರಿಂದ ಪ್ರಾರಂಭವಾಗುವ ನಾಲ್ಕು ವರ್ಷಗಳ ಅವಧಿಯಲ್ಲಿ ಕಾರ್ಯಗತಗೊಳ್ಳಲಿದೆ. ಈ ಕಾರ್ಯಕ್ರಮದ ಪ್ರಾಥಮಿಕ ಮೊದಲ ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯ (MoUD), ಪರಿಸರ ಮತ್ತು ಅರಣ್ಯ ಸಚಿವಾಲಯ (MoEF), UNDP ಮತ್ತು ವಿಶ್ವ ಬ್ಯಾಂಕ್. ಈ ಕಾರ್ಯಕ್ರಮದ ಅನುಷ್ಠಾನಕ್ಕೆ MoUD ನೋಡಲ್ ಏಜೆನ್ಸಿಯಾಗಿದೆ.",
    [HEADING2_P2]:
      "ಸಮಗ್ರವಾದ ಮತ್ತು ವಿಸ್ತಾರವಾದ ಸಂಸ್ಥೆ ಮತ್ತು ಸಾಮರ್ಥ್ಯ ಅಭಿವೃದ್ಧಿ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ರಾಷ್ಟ್ರೀಯ, ರಾಜ್ಯ ಮತ್ತು ಸ್ಥಳೀಯ ಸರ್ಕಾರಗಳ ಮಟ್ಟದಲ್ಲಿ ಅಭಿವೃದ್ಧಿಪಡಿಸಬೇಕು ಮತ್ತು ಕಾರ್ಯಗತಗೊಳಿಸಬೇಕು. ಈಗಾಗಲೇ ತೀವ್ರವಾಗಿ ಮತ್ತು ವೇಗವಾಗಿ ಬೆಳೆಯುತ್ತಿರುವ ನಗರ ಸಾರಿಗೆ ಸವಾಲುಗಳನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಎದುರಿಸಲು ಸಾಕಷ್ಟು ಸಂಸ್ಥೆ ಮತ್ತು ಮಾನವ ಸಾಮರ್ಥ್ಯವನ್ನು ನಿರ್ಮಿಸಲು ಇವು ಅಗತ್ಯವಾಗಿವೆ. ಇದನ್ನು ಗಮನದಲ್ಲಿಟ್ಟುಕೊಂಡು, ಸುಸ್ಥಿರ ನಗರ ಸಾರಿಗೆ ಯೋಜನೆಯನ್ನು (SUTP) ಅಭಿವೃದ್ಧಿಪಡಿಸಲಾಗಿದೆ. SUTP ಯ ಎರಡು ಮುಖ್ಯ ಉದ್ದೇಶಗಳು:",
    [HEADING2_P3]:
      "GOI (ಭಾರತ ಸರ್ಕಾರ), ಇನ್‌ಸ್ಟಿಟ್ಯೂಟ್ ಆಫ್ ಅರ್ಬನ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ (IUT), ಮತ್ತು ಸುಸ್ಥಿರ ನಗರ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆಗಳ ಯೋಜನೆ, ಹಣಕಾಸು, ಅನುಷ್ಠಾನ, ಕಾರ್ಯಾಚರಣೆ ಮತ್ತು ನಿರ್ವಹಣೆಯಲ್ಲಿ ಭಾಗವಹಿಸುವ ರಾಜ್ಯಗಳು ಮತ್ತು ನಗರಗಳ ಸಾಮರ್ಥ್ಯವನ್ನು ಬಲಪಡಿಸುವುದು",
    [HEADING2_P4]: `"ಹಸಿರು ಸಾರಿಗೆ" ಯೋಜನೆಗಳನ್ನು ಸಿದ್ಧಪಡಿಸುವಲ್ಲಿ ಮತ್ತು ಪ್ರದರ್ಶನ ಅನುಷ್ಠಾನಗೊಳಿಸುವಲ್ಲಿ ರಾಜ್ಯಗಳು ಮತ್ತು ನಗರಗಳಿಗೆ ಸಹಾಯ ಮಾಡುವುದು`,
    [HEADING2_P5]:
      "SUTP ಅನ್ನು ಗ್ಲೋಬಲ್ ಎನ್ವಿರಾನ್ಮೆಂಟ್ ಫೆಸಿಲಿಟಿ (GEF), ವಿಶ್ವ ಬ್ಯಾಂಕ್ ಮತ್ತು ಯುನೈಟೆಡ್ ನೇಷನ್ಸ್ ಡೆವಲಪ್ಮೆಂಟ್ ಪ್ರೋಗ್ರಾಂ (UNDP) ಯ ಬೆಂಬಲದೊಂದಿಗೆ GoI ನಿಂದ ಪ್ರಾರಂಭಿಸಲಾಗಿದೆ.",
    [HEADING2_P6]: "ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯ (MoUD) ಯೋಜನೆಯ ನೋಡಲ್ ಏಜೆನ್ಸಿಯಾಗಿದೆ",
    [HEADING2_P7]:
      "ಎಸ್‌ಯುಟಿಪಿ ಅನುಷ್ಠಾನವನ್ನು ಮುಂದಿನ ನಾಲ್ಕು ವರ್ಷಗಳಲ್ಲಿ ಯೋಜಿಸಲಾಗಿದೆ. ಯೋಜನೆಯ ಒಟ್ಟು ವೆಚ್ಚ 1427.97 ಕೋಟಿಗಳು",
    [HEADING2_P8]: "ಹೆಚ್ಚಿನ ವಿವರಗಳಿಗಾಗಿ ಭೇಟಿ ನೀಡಿ: www.sutpindia.com",
    [PARTNERS]: "ಪಾಲುದಾರರು",
    [PARTNERS_P1_1]: "ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯ",
    [PARTNERS_P1_2]: "ಭಾರತ ಸರ್ಕಾರ",

    [PARTNERS_P2_1]: "ಜಾಗತಿಕ ಪರಿಸರ ಸೌಲಭ್ಯ",
    [PARTNERS_P2_2]: "ನಮ್ಮ ಗ್ರಹದಲ್ಲಿ ಹೂಡಿಕೆ",

    [PARTNERS_P3_1]: "ವಿಶ್ವ ಬ್ಯಾಂಕ್",
    [PARTNERS_P3_2]: "ಬಡತನ ಮುಕ್ತ ವಿಶ್ವಕ್ಕಾಗಿ ಕೆಲಸ ಮಾಡುತ್ತಿದೆ",
    [PARTNERS_P4]: "ವಿಶ್ವಸಂಸ್ಥೆಯ ಅಭಿವೃದ್ಧಿ ಕಾರ್ಯಕ್ರಮ",

    [PARTNERS_P5_1]: "ಪರಿಸರ ಮತ್ತು ಅರಣ್ಯ ಸಚಿವಾಲಯ",
    [PARTNERS_P5_2]: "ಭಾರತ ಸರ್ಕಾರ",

    [SUPPORTED_BY]: "ಇವರಿಂದ ಬೆಂಬಲಿತವಾಗಿದೆ",
    [SUPPORTED_BY_P1]: "ನಗರ ಸಾರಿಗೆ ಸಂಸ್ಥೆ (ಭಾರತ)",

    [ITSMC_HEADING]: "ಮೈಸೂರು ನಗರದಲ್ಲಿ ಚತುರ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆ",
    [ITSMC_P1]: "ವಿವರವಾದ ಯೋಜನಾ ವರದಿ",
    [ITSMC_P2]: "ಯೋಜನೆಯ ಒಪ್ಪಂದ",
    [ITSMC_P3]: "ಯೋಜನೆಯ ಒಪ್ಪಂದ",
    [ITSMC_P4]: "ಸಾಲ ಒಪ್ಪಂದ",
    [BID_SEC_HEADING]: "ಬಿಡ್ ವಿಭಾಗ",
    [BID_SEC_P1]: "ITS ಗೆ ಸಂಬಂಧಿಸಿದ ಎಲ್ಲಾ ಟೆಂಡರ್ ಅಧಿಸೂಚನೆಗಳು",

    [BID_SEC_LI1]: "ITS ದಾಖಲೆಗೆ ತಿದ್ದುಪಡಿ",
    [BID_SEC_LI2]: "ಬಿಡ್ ದಾಖಲೆ ITS ಜಾರಿಗೆ ತರುವುದು ",
    [BID_SEC_LI3]: "PMC ಗಾಗಿ EOI",
    [BID_SEC_LI4]: "ITS ಟೆಂಡರ್‌ಗೆ ಪ್ರಶ್ನೆಗಳು ಮತ್ತು ಪ್ರತ್ಯುತ್ತರಗಳು",
    [BID_SEC_LI5]: "EOI ಗಾಗಿ ವಿನಂತಿ - ಮೇಲ್ವಿಚಾರಣೆ ಮತ್ತು ಮೌಲ್ಯಮಾಪನ",
    [BID_SEC_LI6]: "EOI ಗಾಗಿ ತಿದ್ದೋಲೆ  - ಮೇಲ್ವಿಚಾರಣೆ  ಮತ್ತು ಮೌಲ್ಯಮಾಪನ",
    [BID_SEC_LI7]: "ಒಪ್ಪಂದಗಳ ಪ್ರಶಸ್ತಿ",
    [BID_SEC_LI8]: "ಸಮಗ್ರ ಸೇವೆ ಮತ್ತು ಕಾರ್ಯಾಚರಣೆಯ ವಿಶ್ಲೇಷಣೆಗಾಗಿ EOI",

    [SUGGESTIONS]: "ಸಲಹೆಗಳು",
    [SUGGESTIONS_L1]: "ಯಾವುದೇ ದೂರುಗಳು / ಸಲಹೆಗಳಿಗಾಗಿ, ಬರೆಯಿರಿ:",
    [SUGGESTIONS_L2]: "ವ್ಯವಸ್ಥಾಪಕ ನಿರ್ದೇಶಕರು,",
    [SUGGESTIONS_L3]: "ಕರ್ನಾಟಕ ರಾಜ್ಯ ರಸ್ತೆ ಸಾರಿಗೆ ಸಂಸ್ಥೆ,",
    [SUGGESTIONS_L4]: "ಕೇಂದ್ರ ಕಚೇರಿಗಳು, ಸಾರಿಗೆ ಗೃಹ,",
    [SUGGESTIONS_L5]: "ಶಾಂತಿನಗರ, ಬೆಂಗಳೂರು -560027",
    [SUGGESTIONS_L6]: "ಕರ್ನಾಟಕ, ಭಾರತ",
    [SUGGESTIONS_L7_1]: "ಇಮೇಲ್:",
    [SUGGESTIONS_L7_2]: "md@ksrtc.org",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
